import { createFileRoute } from '@tanstack/react-router';

import { PeopleTab } from '@/features/deals';

export const Route = createFileRoute('/_app/deals/$dealId/people')({
  component: function Tab() {
    const { dealId } = Route.useParams();
    return <PeopleTab dealId={dealId} />;
  },
});
